export default __webpack_public_path__ + "static/media/DtVkJx26TKEr37c9aBBxNl4c6SjTjQJElg.f7a727af.woff2";